import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import withModal from '../../../../lib/hoc/withModal';
import ExcelBulkGenerateCouponModal from '../../../../views/coupon/common/modal/ExcelBulkGenerateCouponModal';
import { couponActions } from '../../../../store/modules/coupon';
import { COUPON_ACTIONS_NAME } from '../../../../constants/service/app/couponConstants';

class ExcelBulkGenerateCouponModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      file: null,
    };
  }

  /**
   *  쿠폰 일괄 발급 유효성 체크로 보내기
   */
  onSubmit = () => {
    const { excelBulkGenerateCouponCheck } = this.props;
    const { file } = this.state;

    /**
     *  업로드 한 파일이 없으면 타는 로직
     */
    if (!file) {
      message.error('업로드할 파일을 선택해 주세요.');
      return;
    }

    /**
     *  엑셀 일괄 발급 유효성 체크
     */
    excelBulkGenerateCouponCheck({
      targetAction: {
        name: COUPON_ACTIONS_NAME,
        ...couponActions,
      },
      attachment: [file],
    });

    /**
     * 모달 닫기
     */
    this.closeModal();
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({
      name: 'excelBulkGenerateCouponModal',
      value: false,
    });
  };

  /**
   * 엑셀 파일 변경시 callback
   */
  onChange = (file) => {
    this.setState({
      file,
    });
  };

  render() {
    const { isOpen } = this.props;
    const { file } = this.state;

    return (
      <ExcelBulkGenerateCouponModal
        isOpen={isOpen}
        file={file}
        onSubmit={this.onSubmit}
        onChange={this.onChange}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.coupon.excelBulkGenerateCouponModal.isOpen,
    data: state.coupon.excelBulkGenerateCouponModal.data,
  };
};

const mapDispatchToProps = {
  excelBulkGenerateCouponCheck: couponActions.excelBulkGenerateCouponCheck,
  toggleModal: couponActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(ExcelBulkGenerateCouponModalContainer));
